import { createRoot } from 'react-dom/client';
import React from 'react';
import BetBuilder from './components/BetBuilder';
import { BetProvider } from './context/BetContext';
import { Bet, SelectionsData,MountOptions,Cultures, WidgetConfig } from './types';
import { I18nProvider } from './context/I18nContext';
import { WidgetProvider } from './context/WidgetContext';
import {BET_BUILDER_ACCEPT_ODDS_CHANGES,
        BET_BUILDER_ADD_BETS,
        BET_BUILDER_CHANGE_CULTURE,
        BET_BUILDER_CLEAR_ALL,
        BET_BUILDER_DISABLE,
        BET_BUILDER_RECALCULATE,
        BET_BUILDER_REMOVE_BETS,
        BET_BUILDER_REMOVE_EVENT,
        BET_BUILDER_UPDATE_CONFIG,
        CHANGE_CULTURE,
        DISABLE} from './utils/consts';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './styles.css';
import {generateUniqueId} from './utils/utils'

// Export types for consumers
export type { Bet, SelectionsData };
const __VERSION__= "";
const __ID__= generateUniqueId();
// Mount function to render the widget into a container
export function mount(
  container: HTMLElement, 
  options: MountOptions
) {
  const root = createRoot(container);
   
  root.render(
    <WidgetProvider id ={__ID__}  initialBets={options.initialBets || []} onStateChanged={options.onStateChanged} config={options.config}>
      <I18nProvider>
        <BetProvider
          onBetRemove={options.onBetRemove}
          onClearAll={options.onClearAll}
          onBetAdded={options.onBetAdded}
          onError={options.onError}
          onStateChanged={options.onStateChanged}
          onCultureChanged = {options.onCultureChanged}
          onCultureDisable = {options.onCultureDisable}
          onRecalculate = {options.onRecalculate}
          onEventRemove={options.onEventRemove}
          onEventSelected = {options.onEventSelected}
          
        >
          <BetBuilder />
                  
        </BetProvider>
      </I18nProvider>
    </WidgetProvider>
  );
  
  const dispatchCustomEvent = (eventName: string, detail?: any) => {
    const event = new CustomEvent(eventName, { 
      detail,
      bubbles: true,
      composed: true
    });
    document.dispatchEvent(event);
  };
  dispatchCustomEvent(DISABLE,options.config?.viewOnly);
  dispatchCustomEvent(CHANGE_CULTURE,options.config?.culture);
  return {
    unmount: () => {
      root.unmount();
    },
    addBets: (bets:Bet[]) => {
      dispatchCustomEvent(BET_BUILDER_ADD_BETS,bets);
    },
    removeBets: (removed:Bet[]) => {
      dispatchCustomEvent(BET_BUILDER_REMOVE_BETS,removed);
    },
    recalculate: (calculationData:Bet[]) => {
      dispatchCustomEvent(BET_BUILDER_RECALCULATE,calculationData);
    },
    disable: (disable:boolean) => {
      dispatchCustomEvent(BET_BUILDER_DISABLE,disable);
    },
    acceptOddsChanges: (accept:boolean) => {
      dispatchCustomEvent(BET_BUILDER_ACCEPT_ODDS_CHANGES,accept);
    },
    changeCulture: (culture:Cultures) => {
      dispatchCustomEvent(BET_BUILDER_CHANGE_CULTURE,culture);
    },
    removeEvent: (eventId:number) => {
      dispatchCustomEvent(BET_BUILDER_REMOVE_EVENT,eventId);
    },
    clearAll: () => {      
      dispatchCustomEvent(BET_BUILDER_CLEAR_ALL);
    },
    updateConfig: (config:WidgetConfig) => {      
      dispatchCustomEvent(BET_BUILDER_UPDATE_CONFIG,config);
    },
    version: __VERSION__,
    id: __ID__
  };
}


// Export for UMD/global usage
const BetBuilderWidget = {
  mount: mount
};
// Expose to window when using UMD build
if (typeof window !== 'undefined') {
  (window as any).BetBuilderWidget = BetBuilderWidget;
}
export default BetBuilderWidget;


